
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	View,
} from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

import StyledText from "./StyledText";

import Style from "ae-style";

const styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		badge: {
			borderWidth: 1,
			borderColor: Style.colors.white,
			borderStyle: "solid",
			backgroundColor: Style.colors.highlight,
			justifyContent: "center",
			alignItems: "center",
			position: "absolute",
			borderRadius: 8,
			width: 16,
			height: 16,
			zIndex: 1,
		},
		text: {
			letterSpacing: 0,
		}
	},
	512: {
		badge: {
			borderWidth: 2,
			borderRadius: 11,
			width: 20,
			height: 20,
		}
	}
});

export default function NotificationIcon(props){
	const title = props.title;

	const styleList = [styles.badge];

	const otherStyles = props.style;
	styleList.push(otherStyles);

	return (
		<View style={styleList}>
			<StyledText testID={props.id} style={styles.text} contrast tiny bold inline>{title}</StyledText>
		</View>
	);
}
